import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { FloppyDisk } from "@phosphor-icons/react";

export default function SaveVersionDialog({ open, onOpenChange, onSave }) {
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await onSave(note.trim());
    setSaving(false);
    setNote("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-md max-w-md" data-testid="save-version-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black tracking-tight flex items-center gap-2">
            <FloppyDisk size={20} weight="fill" /> Save Version
          </DialogTitle>
          <DialogDescription className="text-slate-500">
            Take a manual snapshot of the entire project state. You can restore later.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 py-2">
          <div className="space-y-1.5">
            <Label className="text-[10px] uppercase tracking-widest text-slate-500 font-mono-ibm">
              Note (optional)
            </Label>
            <Input
              autoFocus
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="e.g. Pre-kickoff baseline"
              className="h-10 rounded-md border-slate-300"
              data-testid="save-version-note-input"
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="rounded-md border-slate-300">
              Cancel
            </Button>
            <Button type="submit" disabled={saving} className="rounded-md bg-slate-950 hover:bg-slate-800 text-white" data-testid="save-version-submit">
              {saving ? "Saving…" : "Save Snapshot"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
